import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

export interface DetailPageOptions extends PageOptionsBase {
}

export class DetailPage extends PageBase<DetailPageOptions> {

    public init() {
        //DetailPage.msApi = new MultiSelectApi('roles');
        //DetailPage.rolesInit = DetailPage.msApi.getSelectionValues();
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Users/DetailPage.ts
 **/